import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RawDataState {
  dataSource: any[];
}

const initialState: RawDataState = {
  dataSource: [],
};

const rawDataSlice = createSlice({
  name: "rawData",
  initialState,
  reducers: {
    setRawDatas(state, action: PayloadAction<any[]>) {
      state.dataSource = action.payload;
    },
    updateRawDataStatus(
      state,
      action: PayloadAction<{ rawdataId: string; newStatus: any }>
    ) {
      const { rawdataId, newStatus } = action.payload;
      state.dataSource = state.dataSource.map((rawData: any) =>
        rawData._id === rawdataId
          ? {
              ...rawData,
              leadstatus: newStatus,
              updatedAt: new Date().toISOString(),
            }
          : rawData
      );
    },
  },
});

export const { setRawDatas, updateRawDataStatus } = rawDataSlice.actions;
export default rawDataSlice.reducer;
